export default {
  setUser(state, payload) {
    state.loginErr = false;
    state.loginErrMessage = '';
    state.data = payload;
    state.status = 'Fetched';
  },
  setLoginError(state, payload) {
    state.loginErr = true;
    state.loginErrMessage = payload.message;
    state.status = 'Error';
  },
  setToken(state, payload) {
    state.status = 'Fetched';
    state.data = { ...state.data, token: payload };
  },
  updateFetchingUserStatus(state, payload) {
    state.status = payload;
  },
  setRegistrationError(state, error) {
    state.registrationError = error;
  },
  ADD_ACCESS(state, newAccess) {
    state.data.user.access.push(newAccess);
  },
  LOGOUT(state) {
    state.data = {};
    state.loginErr = null;
    state.loginErrMessage = '';
    state.registrationError = '';
    state.status = 'Unfetched';
  },
  LOGIN_COMPLETE(state) {
    state.loginComplete.resolve();
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js